import { useEffect, useState } from "react";
import { FormControl, FormControlLabel, Switch, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import ProgressCirc from "../layout/Progress/ProgressCirc";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";

export default function MySwitch({
  leftSide = "",
  rightSide = "",
  checked = false,
  disabled = false,
  allowChange = true,
  isLoading = false,
  colorize = false,
  onChange,
  onChange2,
  helpId,
}) {
  const theme = useTheme();
  const successColor = theme.palette["success"].main;
  const warningColor = theme.palette["warning"].main;
  const uncheckedOpacity = 0.45;
  const [checkedState, setCheckedState] = useState(checked);

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  const handleChange = (event) => {
    if (!allowChange) return;
    const checked = event.target.checked;
    setCheckedState(checked);
    onChange && onChange(checked);
    onChange2 && onChange2(event);
  };

  const styles = {
    left: {
      opacity: checked ? uncheckedOpacity : 1,
      color: colorize ? warningColor : "inherit",
      transition: "all 0.7s ease-in-out",
    },
    right: {
      opacity: !checked ? uncheckedOpacity : 1,
      color: colorize ? successColor : "inherit",
      transition: "all 0.7s ease-in-out",
    },
    label: {
      opacity: checked ? uncheckedOpacity : 1,
    },
  };

  return (
    <FormControl component="fieldset">
      <div style={{ display: "flex", gap: 3, alignItems: "center" }}>
        <FormControlLabel
          control={<></>}
          value={leftSide}
          label={leftSide}
          labelPlacement="start"
          style={styles.left}
        />
        {isLoading ? (
          <div>
            <ProgressCirc size={20} />
          </div>
        ) : (
          <Switch checked={checkedState} onChange={handleChange} disabled={disabled} />
        )}
        <FormControlLabel
          control={<></>}
          value={rightSide}
          label={rightSide}
          labelPlacement="end"
          style={styles.right}
        />
        <Col_Help />
      </div>
    </FormControl>
  );

  function Col_Help() {
    if (!helpId) return <></>;
    return (
      <div className="center">
        {helpId && helpId.length > 2 && <HelperIcon helpId={helpId} alignRight={false} />}
      </div>
    );
  }
}

MySwitch.propTypes = {
  leftSide: PropTypes.string,
  rightSide: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  helpId: PropTypes.string,
  allowChange: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange2: PropTypes.func,
  colorize: PropTypes.bool,
};
